import Container from "../../../../components/Cards/Container/Container";
import Typography from "../../../../components/Typography/Typography";
import { DASHBOARD_FEATURES, EMPTY_RFX_GENERATOR_DATA } from "../../constants";
import RfxGeneratorDashboardStyles from "./RfxGeneratorDashboard.module.scss";
import ListAltCheckSvg from "../../../../assets/images/list_alt_check.svg";
import { Avatar } from "@mui/material";
import UploadDoc from "../../../../components/UploadDoc/UploadDoc";
import Button from "../../../../components/Button/Button";
import rightArrowSvg from "../../../../assets/images/right_arrow.svg";
import { DASHBOARD_ENTITIES } from "../../../../common/constants";
import Table from "../../../../components/Table/Table";
import {
  reviewPendingApiProp,
  TableTypes,
  tableConfiguration,
} from "../../../ManageContract/constants";
import DownloadSvg from "../../../../assets/images/download_primary_icon.svg";
import ExcelSvg from "../../../../assets/images/excel_icon.svg";
import CloseSvg from "../../../../assets/images/close.svg";
import { useAppDispatch, useAppSelector } from "../../../../hooks/store";
import { getSampleRfxGeneratorDownloadIntakeForm } from "../../../../services/FileUpload.service";
import {
  getRfxGeneratorTemplates,
  removeRfxGeneratorFile,
  resetRfxGeneratorTemplate,
  updateRfxGeneratorData,
} from "../../store/dashboard.thunk";
import WhiteRightArrowSvg from "../../../../assets/images/white_right_arrow.svg";
import { generateRfxGenerator } from "../../../../services/contracts.service";
import { getTableDataThunk } from "../../../../store/thunks/table.thunk";
import { getToast } from "../../../../common/utils";
import infoIconSvg from "../../../../assets/images/UserTable/InfoIcon.svg";
import { useEffect, useState } from "react";
import CustomStepper from "../../../../components/Stepper/Stepper";
import TemplateOptionsRfxGenerator from "./TemplteOptionsRfxGenerator";
import Tooltip from "../../../../components/Tooltip/Tooltip";
import { useSelector } from "react-redux";

const RfxGeneratorDashboard = (props: any) => {
  const [selectedValue, setSelectedValue] = useState<string>("Search Template");
  const { headerText, isRequirements } = props;
  const dispatch = useAppDispatch();
  const isDrafting = headerText === DASHBOARD_FEATURES.RFX_GENERATOR;
  const [openModal, setOpenModal] = useState(false);
  const [isTemplateSelected, setIsTemplateSelected] = useState(false);
  const [loader, setLoading] = useState(false);
  const [current, setCurrent] = useState<number>(0);

  const tableData = useAppSelector(
    (store) => store?.rootReducer?.tableInfoReducer
  )?.data;

  const {
    intakeFormValidated,
    file_name,
    fileUpload,
    templateOptions,
    rfxGeneratorSelectedTemplate,
    docId,
  } = useAppSelector(
    (store) => store?.rootReducer?.vscDashboardReducer
  )?.rfxGenerator;

  const count = useSelector(
    (state: any) =>
      state.rootReducer.tableInfoReducer.data[
        TableTypes.RFX_GENERATOR_DASHBOARD
      ]?.tableData?.count || 0
  );

  const rfxGeneratorUploadingFile = fileUpload?.isUploading;
  const rfxGeneratorFileUploaded = fileUpload?.uploaded;

  const truncateString = (str: string, num: number) => {
    if (str.length <= num) {
      return str;
    }
    return str.slice(0, num) + "...";
  };

  useEffect(() => {
    dispatch(getRfxGeneratorTemplates());
  }, [dispatch]);

  useEffect(() => {
    if (rfxGeneratorFileUploaded && docId) {
      setCurrent(2);
    }
  }, [rfxGeneratorFileUploaded, docId]);

  const handleTemplateChange = (value: string, template: any) => {
    setSelectedValue(value);
    setIsTemplateSelected(true);
    dispatch(
      updateRfxGeneratorData({ rfxGeneratorSelectedTemplate: template })
    );
    setCurrent(1);
  };

  const handleFileCrossClick = (e: any) => {
    e?.preventDefault();
    dispatch(removeRfxGeneratorFile());
    setCurrent(1);
  };

  const handleUploadIntakeForm = () => {
    if (!rfxGeneratorSelectedTemplate?.id) {
      getToast("Error", "Please Choose a Template");
      return;
    }
    setOpenModal(true);
  };

  const handleGenerateClick = async () => {
    setCurrent(3);
    try {
      setLoading(true);
      await generateRfxGenerator({
        rfx_id: docId,
        input_form_id: rfxGeneratorSelectedTemplate?.id,
      });
      getToast("Success", `${isRequirements ? "Requirements" : "RFx"} Generated Successfully`);
      dispatch(
        getTableDataThunk(
          TableTypes.RFX_GENERATOR_DASHBOARD,
          1,
          tableData?.[TableTypes.RFX_GENERATOR_DASHBOARD]?.toBeRetrieved
        )
      );
      dispatch(removeRfxGeneratorFile());
      dispatch(updateRfxGeneratorData(EMPTY_RFX_GENERATOR_DATA));
      setIsTemplateSelected(false);
      setSelectedValue("Search Template");
      setCurrent(0);
    } catch (error) {
      getToast("Error", `${isRequirements ? "Requirements" : "RFx"} Could'nt Be Generated`);
    } finally {
      setLoading(false);
    }
  };

  const handleDownload = async () => {
    if (!rfxGeneratorSelectedTemplate?.id) {
      getToast("Error", "Please select a template");
      return;
    }
    try {
      const intakeFormGcsLoc =
        rfxGeneratorSelectedTemplate?.intake_form_gcs_loc;
      const response = await getSampleRfxGeneratorDownloadIntakeForm(
        intakeFormGcsLoc
      );

      if (response?.intake_form_signed_url) {
        const link = document.createElement("a");
        link.href = response.intake_form_signed_url;
        link.download = "Rfx Input Form.xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        getToast("Error", "Error in Downloading Intake Form");
      }
    } catch (error) {
      getToast("Error", "Error in Downloading Intake Form");
    }
  };

  return (
    <Container
      className={`${
        !isDrafting ? RfxGeneratorDashboardStyles.customContainer : ""
        }`}
    >
      <div className={RfxGeneratorDashboardStyles.cdContainer}>
        <div className={RfxGeneratorDashboardStyles.rfxActionsContainer}>
          <div className={RfxGeneratorDashboardStyles.leftContainer}>
            <div className={RfxGeneratorDashboardStyles.leftHeader}>
              <div className={RfxGeneratorDashboardStyles.draftingIcon}>
                <img src={ListAltCheckSvg} alt="" />
              </div>
              <Typography fontWeight={700} fontSize={12} color="#3474E0">
                {`Generate New ${isRequirements ? "Requirements" : "RFx"}`}
              </Typography>
            </div>

            <div className={RfxGeneratorDashboardStyles.leftCardContent}>
              <div
                className={RfxGeneratorDashboardStyles.templateOptionsWrapper}
              >
                <div
                  className={RfxGeneratorDashboardStyles.templateOptionsHeader}
                >
                  <Avatar
                    style={{
                      backgroundColor: "#3474E00D",
                      color: "#3474E0",
                      border: "1px solid #1E88E5",
                      width: "24px",
                      height: "24px",
                      fontSize: "12px",
                      fontWeight: "700",
                      fontFamily: "Google Sans",
                    }}
                  >
                    {1}
                  </Avatar>
                  <Typography fontWeight={400} fontSize={12} color="#5F6376">
                    {`Choose a template to start generating your ${isRequirements ? "Requirements" : "RFx"}`}
                  </Typography>
                </div>
                <div className={RfxGeneratorDashboardStyles.templateOptions}>
                  <TemplateOptionsRfxGenerator
                    options={templateOptions?.data}
                    onChange={handleTemplateChange}
                    selectedValue={selectedValue}
                    disabled={loader}
                  />
                </div>
              </div>

              {rfxGeneratorSelectedTemplate?.id && (
                <div className={RfxGeneratorDashboardStyles.uploadWrapper}>
                  <div className={RfxGeneratorDashboardStyles.uploadHeader}>
                    <Avatar
                      style={{
                        backgroundColor: "#3474E00D",
                        color: "#3474E0",
                        border: "1px solid #1E88E5",
                        width: "24px",
                        height: "24px",
                        fontSize: "12px",
                        fontWeight: "700",
                        fontFamily: "Google Sans",
                      }}
                    >
                      {2}
                    </Avatar>
                    <Typography fontWeight={400} fontSize={12} color="#5F6376">
                      {`Upload an Intake form to get started with ${isRequirements ? "Requirements" : "RFx"} Generation`}
                    </Typography>
                  </div>

                  <>
                    {rfxGeneratorUploadingFile || rfxGeneratorFileUploaded ? (
                      <div
                        className={
                          RfxGeneratorDashboardStyles.uploadFileWrapper
                        }
                      >
                        <div
                          className={
                            RfxGeneratorDashboardStyles.uploadedFileName
                          }
                        >
                          <img src={ExcelSvg} alt="" />
                          <Typography
                            fontSize={12}
                            fontWeight={400}
                            color="#000000CC"
                          >
                            {truncateString(file_name || "", 20)}
                          </Typography>
                        </div>
                        {!loader && (
                          <img
                            src={CloseSvg}
                            alt=""
                            onClick={handleFileCrossClick}
                          />
                        )}
                      </div>
                    ) : (
                      <Button
                        variant="outlined"
                        style={{
                          backgroundColor: !isTemplateSelected || loader ? "#e0e0e0" : "#fff",
                          borderColor: isTemplateSelected && !loader ? "#3474E0" : "#ccc",
                          color: isTemplateSelected && !loader ? "#3474E0" : "rgba(0, 0, 0, 0.26)",
                          borderRadius: "24px",
                          padding: "4px 12px",
                          width: "95%",
                        }}
                        fullWidth={true}
                        className={RfxGeneratorDashboardStyles.uploadButton}
                        onClick={handleUploadIntakeForm}
                        disabled={!isTemplateSelected || loader || selectedValue === "Search Template"}
                      >
                        Upload Intake Form
                      </Button>
                    )}
                  </>

                  <Typography
                    fontWeight={400}
                    fontSize={12}
                    color="#00000099"
                    marginBottom={4}
                    marginTop={5}
                    style={{ marginTop: "20px" }}
                  >
                    <span style={{ display: "flex", alignItems: "center" }}>
                      Not sure what to upload?{" "}
                      <Tooltip
                        title="Accepted file format- .xlsx"
                        placement="right"
                      >
                        <img
                          src={infoIconSvg}
                          alt="Info Icon"
                          style={{
                            width: "12px",
                            height: "12px",
                            marginLeft: "4px",
                            color: "#D9D9D9",
                          }}
                        />
                      </Tooltip>
                    </span>
                  </Typography>
                  <div
                    style={{
                      display: "flex",
                      gap: "4px",
                      alignItems: "center",
                      marginBottom: "12px",
                    }}
                  >
                    <img src={DownloadSvg} alt="" />
                    <button
                      onClick={handleDownload}
                      style={{
                        background: "none",
                        border: "none",
                        color: "#3474E0",
                        fontSize: "12px",
                        fontWeight: "400",
                        textDecoration: "underline",
                        cursor: "pointer",
                      }}
                    >
                      Download Template
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className={RfxGeneratorDashboardStyles.generateButtonWrapper}>
            {rfxGeneratorSelectedTemplate?.id && rfxGeneratorFileUploaded && (
              <Button
                style={{
                  borderRadius: "24px",
                  width: "98%",
                  fontWeight: "400",
                  fontSize: "12px",
                  padding: "4px 12px",
                }}
                fullWidth={true}
                className={RfxGeneratorDashboardStyles.generateButton}
                disabled={!fileUpload?.uploaded}
                startIcon={
                  !fileUpload?.uploaded ? (
                    <img src={rightArrowSvg} alt="" />
                  ) : (
                    <img src={WhiteRightArrowSvg} alt="" />
                  )
                }
                onClick={handleGenerateClick}
                loading={loader}
              >
                {`Generate ${isRequirements ? "Requirements" : "RFx"}`}
              </Button>
            )}
            <CustomStepper currentStep={current} />
          </div>
        </div>
        <div className={RfxGeneratorDashboardStyles.rfxGeneratorTableContainer}>
          <div className={RfxGeneratorDashboardStyles.headerRightSide}>
            <Avatar
              style={{
                width: "42px",
                height: "42px",
                fontSize: "16px",
                fontWeight: "500",
                fontFamily: "Google Sans",
                backgroundColor: "#3474E00D",
                color: "#3474E0",
                border: "1px solid #1E88E5",
              }}
            >
              {count || 0}
            </Avatar>
            <span className={RfxGeneratorDashboardStyles.headerText}>
              <Typography fontWeight={500} fontSize={14} color="#3474e0">
                {`All Generated ${isRequirements ? "Requirements" : "RFx"}`}
              </Typography>
              <Typography
                fontWeight={400}
                fontSize={12}
                color="#00000099"
                className={RfxGeneratorDashboardStyles.subHeaderText}
              >
                {`Number of generated ${isRequirements ? "Requirements" : "RFx"}`}
              </Typography>
            </span>
          </div>
          <div
            style={{ height: "85%" }}
            className={RfxGeneratorDashboardStyles.rfxGenerateTable}
          >
            <Table
              entity={TableTypes.RFX_GENERATOR_DASHBOARD}
              apiProps={reviewPendingApiProp}
              emptyMessage={isRequirements ? "You have 0 requirements generated" : undefined}
              tableConfig={
                isRequirements
                  ? {
                      ...tableConfiguration[TableTypes.RFX_GENERATOR_DASHBOARD],
                      tableColumns: tableConfiguration[TableTypes.RFX_GENERATOR_DASHBOARD].tableColumns.map(
                        (col: any) =>
                          col.title === "RFx Name"
                            ? { ...col, title: "Requirements Name" }
                            : col
                      ),
                    }
                  : undefined
              }
            />
          </div>
        </div>
      </div>
      <UploadDoc
        openModal={openModal}
        setOpenModal={setOpenModal}
        dashboardEntity={DASHBOARD_ENTITIES.RFX_GENERATOR}
      // postUpload={reTriggerApi}
      />
    </Container>
  );
};

export default RfxGeneratorDashboard;
